import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fury-cover-not-cover',
  templateUrl: './cover-not-cover.component.html',
  styleUrls: ['./cover-not-cover.component.scss']
})
export class CoverNotCoverComponent implements OnInit {

  @Input('status') status!: any;
  @Input('city') City?: string;
  @Input('state') State?: string;
  @Input('leadId') LeadId?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
